import { AssetBucketUrlPrefix } from '../../../utils/Constants';

const linesOfCodeAssetBucketPrefix = `${AssetBucketUrlPrefix}/lines-of-code-images`;
export const linesOfCodeText = {
  title: '200K+',
  subtitle: 'LINES OF CODE',
  contentItems: [
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectMoonPlacesVisited.webp`,
      alt: 'Image of a Japanese temple in a carousel component of a website',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/depthDetection.webp`,
      alt: 'Image of several cones and a mask in blue to orange gradient',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/jumpBoxGame.webp`,
      alt: 'Image of a website with a image of a game with red and white squares',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/panoramaStitching.webp`,
      alt: 'Two of the same images side by side with lines drawn from points in one to the same points in the other',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/pedestrianDetection.webp`,
      alt: 'Image of pedestrians walking with green boxes surrounding each person',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectMoonHome.webp`,
      alt: 'Image of a homepage of a website with three circles in a triangular formation in the center',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectMoonOld.webp`,
      alt: 'Image of a website with a grid of text in a rectangle with an image of the moon on the right',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectWindExperience.webp`,
      alt: 'Image of a website with an image of a samurai sitting in the middle',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectWindHome.webp`,
      alt: 'Image of a home page of a website with a logo of a cloud and a black background',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/ggDeadIsland2.webp`,
      alt: 'Image of an Amazon.com product page of a video game',
      yTransformOverride: [-600, 400],
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/turboCheckout.webp`,
      alt: 'Image of a modal on a website to verify information before purchasing a game',
      yTransformOverride: [-600, 400],
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectMoonOldStats.webp`,
      alt: 'Image of a grid of text with statisics',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectMoonOldExperience.webp`,
      alt: "Image of a female holding a sword with text on it's left",
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/seattleHouseListingCongestion.webp`,
      alt: 'Image of a map with a heat map showing congested areas in red',
      yTransformOverride: [-600, 400],
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/bruteForce.webp`,
      alt: 'Image of a terminal and several leaked passwords on the left',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/cannyLandscape.webp`,
      alt: 'Image of a black image with a white outline of a picture in a Japanese city',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/studyBubble.webp`,
      alt: 'Image of a website with posts on the left and section to create a new post on the right',
      yTransformOverride: [-600, 400],
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/ggDetailPage2.webp`,
      alt: 'Image of an Amazon.com product page selling a video game',
      yTransformOverride: [-600, 400],
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/ggDetailPage1.webp`,
      alt: 'Image of an Amazon.com product page of a video game',
      yTransformOverride: [-600, 400],
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/characterRecognition.webp`,
      alt: 'Large characters in black on a white background',
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/quarantinePoster.webp`,
      alt: 'Image of a mobile phone app showing a list of groceries and their expiration status',
      yTransformOverride: [-2500, 400],
    },
    {
      imgSrc: `${linesOfCodeAssetBucketPrefix}/projectWindMain.webp`,
      alt: 'Image of home page of a website with gray wind in the background',
      yTransformOverride: [-600, 400],
    },
  ],
};
